"use client";

import {
  FeatureFlagProvider,
  FiatPricingProvider,
  GlobalWishlistProvider,
  PassportProvider,
  QueryProvider,
} from "@/context";
import { AssetImportProvider } from "@/context/AssetImportProvider";
import { PreferencesProvider } from "@/context/PreferencesProvider";
import { ProfileDrawerProvider } from "@/context/ProfileDrawerContext";
import theme from "@/styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import type { ReactNode } from "react";
import "../i18n";
import { AnalyticsProvider } from "@/context/AnalyticsProvider";
import { BrazeProvider } from "@/context/BrazeProvider";
import { PWAInstallProvider } from "@/context/PWAInstallContext";

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <PWAInstallProvider>
      <AnalyticsProvider>
        <PassportProvider>
          <GlobalWishlistProvider>
            <FeatureFlagProvider>
              <QueryProvider>
                <PreferencesProvider>
                  <FiatPricingProvider>
                    <AssetImportProvider>
                      <ProfileDrawerProvider>
                        <BrazeProvider>
                          <ThemeProvider theme={theme}>
                            {children}
                          </ThemeProvider>
                        </BrazeProvider>
                      </ProfileDrawerProvider>
                    </AssetImportProvider>
                  </FiatPricingProvider>
                </PreferencesProvider>
              </QueryProvider>
            </FeatureFlagProvider>
          </GlobalWishlistProvider>
        </PassportProvider>
      </AnalyticsProvider>
    </PWAInstallProvider>
  );
}
